import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Music, Star, Flame, Award, Trophy, BadgeCheck, Target, Medal, Lock } from "lucide-react";
import { childApi } from "../lib/api";

const ICONS = { music: Music, star: Star, flame: Flame, award: Award, trophy: Trophy, "badge-check": BadgeCheck, target: Target, medal: Medal };

export default function ChildBadges() {
  const [rows, setRows] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    childApi.get("/child/achievements").then((r) => setRows(r.data.achievements));
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF7EE]" data-testid="badges-page">
      <header className="bg-[#0B192C] text-[#FAF7EE] px-5 py-5">
        <div className="max-w-3xl mx-auto flex items-center gap-3">
          <button onClick={() => navigate("/play/home")} aria-label="Back" data-testid="back-btn"
            className="p-2.5 rounded-full hover:bg-white/10 min-h-[48px] min-w-[48px] flex items-center justify-center">
            <ArrowLeft className="w-5 h-5" />
          </button>
          <h1 className="font-display font-bold text-xl">My Achievements</h1>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-8">
        <div className="grid gap-4 grid-cols-2 sm:grid-cols-3">
          {(rows || []).map((a) => {
            const Icon = ICONS[a.icon] || Award;
            return (
              <div key={a.id} data-testid={`achievement-${a.key}`}
                className={`rounded-2xl border p-5 text-center transition-all ${a.earned
                  ? "bg-white border-[#C69B3D] shadow-sm"
                  : "bg-[#F3EFE0]/50 border-[#E5DEC9] opacity-70"}`}>
                <div className={`w-12 h-12 mx-auto rounded-full flex items-center justify-center ${a.earned ? "bg-[#C69B3D] text-[#0B192C]" : "bg-[#E5DEC9] text-[#566270]"}`}>
                  {a.earned ? <Icon className="w-6 h-6" aria-hidden /> : <Lock className="w-5 h-5" aria-hidden />}
                </div>
                <h3 className="font-display font-bold text-sm text-[#0B192C] mt-3">{a.name}</h3>
                <p className="text-xs text-[#566270] mt-1">{a.description}</p>
                {a.earned && a.earned_at && (
                  <p className="text-[10px] text-[#2D6A4F] font-bold mt-2">
                    Earned {new Date(a.earned_at).toLocaleDateString("en-GB")}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </main>
    </div>
  );
}
